import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

// Mirrors NewGlobalSearchAudiencePage.tsx's defaultBottomSheetPosition (the collapsed
// bottom-sheet height) — kept as a local constant instead of importing that page's export, to
// avoid coupling this shared a2ui component to a specific page module.
export const MOBILE_SHEET_COLLAPSED_HEIGHT = 116;

export const ModalLayout = styled.div`
  display: flex;
  gap: 1rem;
  height: 32rem;
`;

export const MapArea = styled.div`
  flex: 1;
  min-width: 0;
  border-radius: 0.75rem;
  overflow: hidden;
`;

export const SidePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 20rem;
  overflow-y: auto;
`;

export const FiltersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// Fullscreen mobile layout: map behind, top bar and bottom sheet above it.
// z-index ordering mirrors NewGlobalSearchAudiencePage.styles.tsx (map at the base, controls
// above it, bottom sheet's own zIndex prop — 9000/9001 — on top of everything).
export const MobileOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
`;

export const MobileMapArea = styled.div`
  position: fixed;
  inset: 0;
`;

export const MobileTopBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const MobileSheetTitle = styled.h3`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.m};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  margin: 0 0 1rem 0;
`;

export const ConfirmationButtonsRow = styled.div`
  display: flex;
  gap: 0.75rem;

  & > button {
    flex: 1;
  }
`;

export const TriggerSubtitle = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  margin-top: 0.25rem;
`;
